<!-- TEMPLATE -->
<template>
<div class="content" style="padding-top: 0px;">
   <v-alert
        v-model="alertSuccess"
        dismissible
        border="left"
        elevation="2"
        dense
        text
        type="success"
        icon="mdi-checkbox-marked-circle"
      >
        Settings updated successfully
      </v-alert>
       <v-alert
        v-model="alertError"
        dismissible
        dense
        text
        type="error"
        border="left"
        elevation="2"
        icon="mdi-alert-circle"
      >
        There was an error. Please try again
      </v-alert>
  
  <div class="row">
    <div class="col-md-8">
      <div class="card">
        <div class="card-header">
          <h5 class="title"> Profile</h5>
        </div>
        <div class="card-body">
    
            <v-row>
              <v-col lg="12">
               
                  <label>Username</label>
                  <input type="text" class="form-control" disabled="" v-model="email">
         
              </v-col>
             </v-row> 
              <v-row>
              <v-col lg="12">
                  <label>API KEY</label>
                  <input type="text" disabled class="form-control" style="color: white" placeholder="" v-model="apiKey">
             
              </v-col>
            </v-row>
               <v-row>
                <v-col lg="12">
                  <label>Preferred domain</label>
                   <!-- domain list -->
                    <select class="custom-select" name="domain_selector" id="dropdown_domain_list" 
                        v-model="selected"
                        @change="selectOption(selected)"
                            >
                    <option disabled value="">Please select one</option>
                    <option v-for="item in domains" v-bind:value="item" v-bind:key="item" >
                        {{ item }}
                    </option>
                  </select>   
                    </v-col>
              </v-row>
           
            </div>
        
      </div>
     
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card-header">
            <h5 class="title">Your team</h5>
            <h5 ></h5>
          </div>
          <div class="card-body">
            <ul id="example-1">
              <li v-for="item in usersCompanyList" :key="item.id">
               <v-icon small dark>mdi-account-outline</v-icon> {{ item }}
             </li>
            </ul>
          </div>
        </div>



      <div class="card">
          <div class="card-header">
            <h5 class="title">Alerting</h5>
            <h5 ></h5>
          </div>
         <div class="card-body">
              <v-row align="center" justify="center">
                <v-col justify="center" lg="9" style="color:white;">
                  <v-icon small dark>mdi-email</v-icon> 
                    {{email}}    
                 </v-col>
                 <v-col  lg="2">
               <v-switch
                    v-model="email_notifications"
                    @change="changeStatus(email_notifications)"
                    single-line
                    counter
                    color="primary"
                    autofocus
                ></v-switch>
                   </v-col>
               </v-row>
          </div>
        </div>



      </div>

      </div>
      <v-row>
        <v-col lg="12">
        <div class="card">
          <div class="card-header">
            <h5 class="title">Download the JavaScript agent for your website(s)</h5>
          </div>
          <div class="card-body">
            <v-row>
              <v-col lg="11">
                <DomainListDropdown />
              </v-col>
              <v-col lg="1" style="margin-top:-3px">
                <v-btn @click="getJavascript()" outlined dark class="btn btn-fill btn-primary" ><v-icon class="fab">mdi-download</v-icon> </v-btn>
              </v-col>   
            
            </v-row>
          </div>
        </div>
         </v-col>
        </v-row>
      <v-row>
        <v-col lg="12">
       <v-btn  v-on:click="saveSettings()" outlined dark class="float-right btn btn-fill btn-primary" ><v-icon class="fab">mdi-content-save</v-icon> </v-btn>
       </v-col>
       </v-row> 

    </div>

  </div>

</template>


<!-- SCRIPT -->
<script>
import PhishingApi from "../app/phishing-api";
import DomainListDropdown from "./DomainListDropdown.vue";
export default {
  name: "Settings",
  data: function () {
    return {
      alertError: false,
      alertSuccess: false,
      userInfo: this.$store.state.cognitoInfo,
      customerName: "",
      email: "",
      apiKey: "",
      clientJS: "",
      licenseNumber: "",
      licenseExpiryDate: "",
      usersCompanyList: [],
      domains: [],
      defaultDomainIndex: 1,
      selected: "",
      email_notifications: false,
    };
  },
  created() {
    this.fetchData();
  },
  computed: {},
  methods: {
    fetchData() {
      PhishingApi.getSettingsDetails()
        .then((response) => {
          this.customerName = response["customer_name"];
          this.email = response["email"];
          this.apiKey = response["api_key"];
          this.licenseNumber = response["license"];
          this.licenseExpiryDate = response["expiration"];
          this.usersCompanyList = response["users"];
          this.domains = response["domains"];
          this.defaultDomainIndex = response["default_domain_index"];
          this.selected = this.domains[response["default_domain_index"]];
          this.email_notifications = response["email_notifications"];
        })
        .catch(function (error) {
          console.log(error);
        });
      //TODO: get javascript
    },

    getReadableDate(value) {
      return new Date(value * 1000).toLocaleString();
    },
    changeStatus(status) {
      this.email_notifications = status;
    },
    getJavascript() {
      let self = this;
      PhishingApi.getJavascriptForDomain(this.$store.getters.activeDomain)
        .then(function (response) {
          let domain = self.$store.getters.activeDomain;
          let filename = "agent_" + domain.replace(".", "_") + ".js";
          PhishingApi.forceJsFileDownload(response, filename);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    saveSettings() {
      let self = this;
      PhishingApi.setSettingsDetails(
        this.customerName,
        this.defaultDomainIndex,
        this.email_notifications
      )
        .then(function (response) {
          console.log("Success: update page");
          self.alertSuccess = true;
        })
        .catch(function (error) {
          self.alertError = true;
          console.log(error);
        });
    },
    selectOption(selected) {
      this.defaultDomainIndex = this.domains.indexOf(selected);
    },
  },
  filters: {
    toReadableDate(value) {
      return new Date(value * 1000).toLocaleString();
    },
  },
  components: {
    DomainListDropdown,
  },
};
</script>

<!-- Style -->
<style>
</style>